(function () {
  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || (window.themeMoneyFormat || '${{amount}}'));
    }
    var amount = (Number(cents) / 100).toFixed(2);
    return '$' + amount;
  }

  function initProduct(section) {
    if (section.dataset.productInitialized) return;
    section.dataset.productInitialized = 'true';
    var productJsonEl = section.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    var form = section.querySelector('[data-product-form]');
    var variantInput = section.querySelector('[data-variant-id]');
    var optionSelects = section.querySelectorAll('[data-option-select]');
    var priceEl = section.querySelector('[data-product-price]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var addText = section.querySelector('[data-add-to-cart-text]');
    var mainImg = section.querySelector('[data-gallery-main] img');
    var thumbs = section.querySelectorAll('[data-gallery-thumbs] [data-media-id]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyDec = section.querySelector('[data-qty-decrease]');
    var qtyInc = section.querySelector('[data-qty-increase]');
    var statusEl = section.querySelector('[data-variant-status]');
    var zoomLink = section.querySelector('[data-zoom-open]');
    var sticky = section.querySelector('[data-sticky-purchase]');
    var stickyAdd = section.querySelector('[data-sticky-add]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyOptions = section.querySelector('[data-sticky-options]');
    var masterSelect = section.querySelector('[data-master-select]');
    var optionUi = section.querySelector('[data-option-ui]');
    if (optionUi && optionSelects.length) {
      optionUi.hidden = false;
      if (masterSelect) {
        var masterField = masterSelect.querySelector('select');
        if (masterField) masterField.disabled = true;
        masterSelect.hidden = true;
      }
      if (variantInput) variantInput.disabled = false;
    }
    var prices = {};
    try { prices = JSON.parse(section.querySelector('[data-variant-prices]').textContent); } catch (e) { /* Keep the rendered price if price data is missing. */ }

    function findVariant() {
      if (!optionSelects.length) {
        return product.variants[0];
      }
      var selected = Array.prototype.map.call(optionSelects, function (sel) {
        return sel.value;
      });
      return product.variants.find(function (v) {
        return selected.every(function (val, i) {
          return v.options[i] === val;
        });
      });
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (btn) {
        var active = String(btn.getAttribute('data-media-id')) === String(mediaId);
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateGallery(mediaId) {
      if (!mediaId || !mainImg) return;
      var thumb = section.querySelector('[data-gallery-thumbs] [data-media-id="' + mediaId + '"]');
      if (!thumb) thumb = section.querySelector('[data-gallery-thumbs] [data-image-id="' + mediaId + '"]');
      if (!thumb) return;
      var src = thumb.getAttribute('data-media-src');
      var srcset = thumb.getAttribute('data-media-srcset');
      var alt = thumb.getAttribute('data-media-alt') || '';
      if (src) mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      if (zoomLink) zoomLink.href = thumb.getAttribute('data-media-zoom') || src;
      mainImg.alt = alt;
      mainImg.setAttribute('data-media-id', thumb.getAttribute('data-media-id'));
      setActiveThumb(thumb.getAttribute('data-media-id'));
    }

    function renderPrice(variant) {
      if (!priceEl || !variant) return;
      var formatted = prices[variant.id];
      var html = '<span class="price">' + (formatted ? formatted.price : money(variant.price));
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <s class="price__compare">' + (formatted ? formatted.compare : money(variant.compare_at_price)) + '</s>';
        html += ' <span class="badge badge--sale badge--inline">Sale</span>';
      }
      html += '</span>';
      priceEl.innerHTML = html;
    }

    function updateOptionStates() {
      var selected = Array.prototype.map.call(optionSelects, function (select) { return select.value; });
      optionSelects.forEach(function (select, index) {
        Array.prototype.forEach.call(select.options, function (option) {
          var matches = product.variants.filter(function (variant) {
            return variant.options[index] === option.value && selected.every(function (value, otherIndex) {
              return otherIndex === index || variant.options[otherIndex] === value;
            });
          });
          var suffix = !matches.length ? ': unavailable combination' : matches.some(function (variant) { return variant.available; }) ? '' : ': sold out';
          option.textContent = option.value + suffix;
        });
      });
    }

    function updateVariant() {
      var variant = findVariant();
      updateOptionStates();
      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'Unavailable'; }
        if (statusEl) statusEl.textContent = 'This combination is unavailable. Please choose another option.';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      renderPrice(variant);
      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stickyAdd) { stickyAdd.disabled = !variant.available; stickyAdd.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
      if (stickyPrice) stickyPrice.textContent = prices[variant.id] ? prices[variant.id].price : money(variant.price);
      if (stickyOptions) stickyOptions.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (statusEl) statusEl.textContent = (variant.title === 'Default Title' ? '' : variant.title + ' · ') + (prices[variant.id] ? prices[variant.id].price : money(variant.price)) + ' · ' + (variant.available ? 'In stock' : 'Sold out');

      var mediaId = variant.featured_media && variant.featured_media.id
        ? variant.featured_media.id
        : (variant.featured_image && variant.featured_image.id);
      if (mediaId) updateGallery(mediaId);

      if (variant.id && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });

    updateOptionStates();
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; }).observe(addBtn);
    }
    if (form) form.addEventListener('submit', function (event) {
      var variant = findVariant();
      if (!variant || !variant.available || !variantInput.value) {
        event.preventDefault();
        if (statusEl) { statusEl.textContent = 'Please select an available option before adding this item.'; statusEl.tabIndex = -1; statusEl.focus(); }
      }
    });

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateGallery(btn.getAttribute('data-media-id'));
      });
    });

    if (qtyDec && qtyInput) {
      qtyDec.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
    }
    if (qtyInc && qtyInput) {
      qtyInc.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = v;
      });
    }

    section.querySelectorAll('[data-size-guide-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var guide = document.getElementById(link.hash.slice(1));
        if (guide) { guide.open = true; var summary = guide.querySelector('summary'); if (summary) summary.focus(); }
      });
    });

    var dialog = section.querySelector('[data-image-dialog]');
    var dialogImage = section.querySelector('[data-dialog-image]');
    var counter = section.querySelector('[data-zoom-counter]');
    var priorOverflow = '';
    var zoomIndex = 0;
    function showZoomImage(index) {
      if (!dialogImage) return;
      if (thumbs.length) {
        zoomIndex = (index + thumbs.length) % thumbs.length;
        var thumb = thumbs[zoomIndex];
        dialogImage.src = thumb.getAttribute('data-media-zoom') || thumb.getAttribute('data-media-src');
        dialogImage.alt = thumb.getAttribute('data-media-alt') || product.title;
      } else if (zoomLink && mainImg) { dialogImage.src = zoomLink.href; dialogImage.alt = mainImg.alt; }
      if (counter) counter.textContent = (zoomIndex + 1) + ' of ' + (thumbs.length || 1);
    }
    if (dialog && zoomLink && typeof dialog.showModal === 'function') {
      zoomLink.addEventListener('click', function (event) {
        event.preventDefault();
        zoomIndex = Array.prototype.findIndex.call(thumbs, function (thumb) { return thumb.getAttribute('aria-pressed') === 'true'; });
        showZoomImage(Math.max(0, zoomIndex));
        priorOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
      });
      dialog.querySelector('[data-dialog-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () { document.body.style.overflow = priorOverflow; zoomLink.focus(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); showZoomImage(zoomIndex + (event.key === 'ArrowLeft' ? -1 : 1)); }
      });
      dialog.querySelector('[data-zoom-prev]').addEventListener('click', function () { showZoomImage(zoomIndex - 1); });
      dialog.querySelector('[data-zoom-next]').addEventListener('click', function () { showZoomImage(zoomIndex + 1); });
      if (thumbs.length < 2) { dialog.querySelector('[data-zoom-prev]').hidden = true; dialog.querySelector('[data-zoom-next]').hidden = true; }
    }

    try {
      var context = JSON.parse(sessionStorage.getItem('ww:browse-context') || 'null');
      if (context && Number.isFinite(context.timestamp) && Date.now() - context.timestamp >= 0 && Date.now() - context.timestamp < 3600000) {
        var contextUrl = new URL(context.url, location.origin);
        var referrer = document.referrer ? new URL(document.referrer) : null;
        var contextProduct = context.productUrl ? new URL(context.productUrl, location.origin) : null;
        var productMatches = contextProduct ? contextProduct.origin === location.origin && contextProduct.pathname === location.pathname : referrer && referrer.origin === location.origin && referrer.pathname === contextUrl.pathname;
        if (productMatches && contextUrl.origin === location.origin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:collections(?:\/|$)|search(?:\/|$))/.test(contextUrl.pathname)) {
          var back = section.querySelector('[data-back-results]');
          var label = typeof context.title === 'string' ? context.title.slice(0, 100) : 'results';
          if (back) { back.href = contextUrl.pathname + contextUrl.search; back.hidden = false; back.querySelector('[data-back-results-label]').textContent = 'Back to ' + label; }
          var crumb = section.querySelector('[data-product-breadcrumb]');
          if (crumb) { crumb.href = contextUrl.pathname + contextUrl.search; crumb.textContent = label; }
        }
      }
    } catch (e) { /* Browsing remains usable when browser storage is unavailable. */ }
  }

  function initRecommendations(root) {
    root.querySelectorAll('[data-product-recommendations]').forEach(function (container) {
      if (container.dataset.loaded) return;
      container.dataset.loaded = 'true';
      var url = new URL(container.dataset.recommendationsUrl, location.origin);
      if (url.origin !== location.origin) return;
      fetch(url.href, {credentials: 'same-origin'}).then(function (response) { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); }).then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var recommendations = documentFragment.querySelector('[data-product-recommendations]');
        if (recommendations && recommendations.querySelector('.product-card')) { container.innerHTML = recommendations.innerHTML; container.hidden = false; document.dispatchEvent(new CustomEvent('ww:products-updated')); }
      }).catch(function () { container.hidden = true; });
    });
  }
  function initialize(root) { root.querySelectorAll('.product-section').forEach(initProduct); initRecommendations(root); }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
